import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMount, useUpdateEffect } from 'react-use';
import { managerIn, signIn, setMode } from '../modules/manager';
import Signin from '../components/manager/Signin';
import ManagerIn from '../components/manager/ManagerIn';
import { getManagerMode } from '../common/util';

const SigninPage = () => {
  const dispatch = useDispatch();
  const {
    error: e,
    isLoggedIn,
    bManage,
  } = useSelector((state) => state.manager);
  const [state, setState] = useState({
    userId: '',
    password: '',
    serial: '',
  });
  const [error, setError] = useState({
    userId: '',
    password: '',
    login: '',
  });
  const history = useHistory();
  const errors = {
    userId: '아이디를 입력하세요.',
    password: '비밀번호를 입력하세요.',
    login:
      '아이디 또는 비밀번호를 확인하세요. \n 등록되지 않은 아이디거나, 아이디 또는 비밀번호를 잘못 입력하였습니다.',
    managerLogin: '아이디 또는 로봇 시리얼을 확인하세요.',
    temp: '인증되지 않은 계정입니다. 이메일 인증을 완료해주세요.',
    unknown: '알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.',
    serial: '시리얼 번호를 입력하세요.',
  };

  const strings = {
    title: '서큘러스 관리자 계정으로 로그인하세요.',
    buttonText: '로그인',
    userIdLabel: '아이디',
    userIdPlaceholder: '아이디를 입력하세요.',
    passwordLabel: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요.',
  };

  const validation = (name, value) => {
    if (value.length < 1)
      setError((prevError) => ({
        ...prevError,
        [name]: errors[name],
        login: '',
      }));
    else
      setError((prevError) => ({
        ...prevError,
        [name]: '',
        login: '',
      }));
  };
  const onChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    validation(name, value);
  };

  const handleSignup = () => history.push('/signup');

  const handleSignIn = (event) => {
    if (event) event.preventDefault();
    if (!state.userId || !state.password || error.userId || error.password) {
      setError({ userId: '', password: '', login: errors.login });
      return;
    }
    dispatch(
      signIn({ userId: state.userId.trim(), password: state.password.trim() }),
    );
  };

  const handleManagerIn = (event) => {
    if (event) event.preventDefault();
    if (!state.userId || !state.serial || error.userId || error.serial) {
      setError({ userId: '', password: '', login: errors.managerLogin });
      return;
    }
    dispatch(
      managerIn({ userId: state.userId.trim(), serial: state.serial.trim() }),
    );
  };

  useEffect(() => {
    if (e && e.login) {
      setError({ userId: '', password: '', login: e.login });
    }
  }, [e]);

  useUpdateEffect(() => {
    if (isLoggedIn && getManagerMode()) {
      history.replace('/manager');
    }
  }, [isLoggedIn]);

  useEffect(() => {
    setState({
      userId: '',
      password: '',
      serial: '',
    });
    setError({
      userId: '',
      password: '',
      login: '',
    });
  }, [bManage]);

  useMount(() => dispatch(setMode(false)));

  return (
    <>
      {!bManage && (
        <Signin
          {...{
            strings,
            handleSignup,
            handleSignIn,
            handleManagerIn: () => dispatch(setMode(true)),
            onChange,
            state,
            error,
          }}
        />
      )}
      {bManage && (
        <ManagerIn
          {...{
            strings: {
              title: '관리할 로봇의 매니저 아이디와 시리얼로 로그인하세요.',
              buttonText: '로그인',
              userIdLabel: '매니저 아이디',
              userIdPlaceholder: '매니저 아이디를 입력하세요.',
              serialLabel: '로봇 시리얼',
              serialPlaceholder: '로봇 시리얼을 입력하세요.',
            },
            handleManagerIn,
            handlePrev: () => dispatch(setMode(false)),
            onChange,
            state,
            error,
          }}
        />
      )}
    </>
  );
};

export default SigninPage;
